<fieldset *ngIf="form as form" [formGroup]="form">
  <legend>
    Dla rodzin wielodzietnych które posiadają kartę dużej rodziny
  </legend>
  <div class="row">
    <div class="col-12">
      <br>
      <div class='form-group' *ngIf='"cardIsPresent" as controlName'>
        <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
          <input
            #input
            (change)="form.cardIsPresentChange(input.checked)"
            [formControlName]='controlName'
            type='checkbox'
            [id]='controlName'
            [name]='controlName'>
          <label [for]='controlName'>
            * Posiadam Kartę Dużej Rodziny fizycznie
          </label>
        </div>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    @if (form.largeFamiliesCount) {
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"largeFamiliesCount" as controlName'>
          <label [for]='controlName'>
            <br>
            Liczba rodzin wielodzietnych *
          </label>
          <input
            mask='0*'
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu liczbę'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    }
    @if (form.largeFamiliesTotalPersonsCount) {
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"largeFamiliesTotalPersonsCount" as controlName'>
          <label [for]='controlName'>
            Łączna liczba osób w <br> rodzinie(-nach) wielodzietnej(-nych) *
          </label>
          <input
            mask='0*'
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu liczbę'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    }
  </div>
  @if (form.cards) {
    <fieldset>
      <legend>
        Posiadacze karty dużej rodziny
      </legend>
      <app-large-family-cards-crud [formControl]="form.cards">
      </app-large-family-cards-crud>
    </fieldset>
  }
</fieldset>
